import { useState } from "react";
import {
  Button,
  Card,
  NumberInput,
  Stack,
  Title,
  Text,
  Center,
  Alert,
} from "@mantine/core";
import { IconCashRegister, IconAlertCircle } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import { useOpenShift } from "../../../shared/api";

export function ShiftOpenPage({ onOpened }: { onOpened: () => void }) {
  const [openingCash, setOpeningCash] = useState<number>(0);
  const [error, setError] = useState<string | null>(null);
  const openShift = useOpenShift();

  async function handleOpen() {
    setError(null);
    try {
      await openShift.mutateAsync({ opening_cash_minor: Math.round(openingCash * 100) });
      notifications.show({ message: "Kasa açıldı", color: "green" });
      onOpened();
    } catch (e: any) {
      setError(e?.response?.data?.detail || "Kasa açılamadı");
    }
  }

  return (
    <Center h="100vh" bg="gray.0" p="md">
      <Card padding="xl" radius="lg" withBorder shadow="md" w="100%" maw={420}>
        <Stack gap="lg">
          <Center>
            <IconCashRegister size={48} color="var(--mantine-color-blue-6)" />
          </Center>
          <Stack gap={4}>
            <Title order={2} ta="center">
              Kasa Açılışı
            </Title>
            <Text c="dimmed" ta="center" size="sm">
              Kasada başlangıç nakit tutarını girin
            </Text>
          </Stack>

          {error && (
            <Alert color="red" icon={<IconAlertCircle size={16} />}>
              {error}
            </Alert>
          )}

          <NumberInput
            label="Başlangıç Nakit (TL)"
            value={openingCash}
            onChange={(v) => setOpeningCash(Number(v) || 0)}
            size="lg"
            min={0}
            decimalScale={2}
            thousandSeparator=","
          />

          <Button size="lg" onClick={handleOpen} loading={openShift.isPending} fullWidth>
            Kasayı Aç
          </Button>
        </Stack>
      </Card>
    </Center>
  );
}
